define('lib/Podio.UI.SpaceNavigation',['require','react','react-dom','underscore','jquery','lib/Podio.Transport.Apps','lib/Podio.UI.Space.ShareSpaceModal','lib/Podio.UI.Modal','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Config','lib/Podio.Utils','component!AddAppModalComponent'],function(require) {

  var React = require('react');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');
  var $ = require('jquery');
  var transportApps = require('lib/Podio.Transport.Apps');
  var shareSpaceModal = require('lib/Podio.UI.Space.ShareSpaceModal');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var podioConfig = require('lib/Podio.Config');
  var utils = require('lib/Podio.Utils');

  var AddAppModalComponent = React.createFactory(require('component!AddAppModalComponent'));

  var elmSpaceNavigation, elmSpaceNavigationAppNav, elmSpaceNavigationToggleAllApps;
  var pressTimer, _addAppModalNode, _addAppModalInstance;

  var open = false;
  var helpers = {
    showAllApps : function() {
      if (!open) {
        open = true;
        elmSpaceNavigation.addClass('show-all');
        helpers.toggleMoreAppsArrow();
        elmSpaceNavigation.find('.arrow,.arrow-border').hide();
      }
    },
    hideAllApps : function() {
      if (open) {
        open = false;
        elmSpaceNavigation.removeClass('show-all');
        helpers.toggleMoreAppsArrow();
        elmSpaceNavigation.find('.arrow,.arrow-border').show();
      }
    },
    toggleMoreAppsArrow : function() {
      elmSpaceNavigationToggleAllApps.find('span').toggleClass('icon-24-grey-arrow-down icon-24-grey-arrow-right');
    }
  };

  function onReorderingChange() {
     var app_ids = [];

     elmSpaceNavigationAppNav.find('li.drag-helper').removeClass('drag-helper');
     $('.space-navigation-reorder-overlay').remove();

     elmSpaceNavigationAppNav.find('li:not(.core)').each(function() {
       app_ids.push($(this).data('app-id'));
     });

     transportApps.update_order(app_ids);
   }

  function onReorderingStart() {

  }

  function activateReordering() {
    if (elmSpaceNavigationAppNav.hasClass('reorder-active')) {
      return;
    }

    elmSpaceNavigationAppNav.find('a').each(function() {
      var elmLink = $(this);
      elmLink.attr('data-href', elmLink.attr('href'));
      elmLink.attr('href', '#');
    });

    elmSpaceNavigationAppNav.sortable({
      items: "li:not(.core)",
      placeholder: 'app highlight',
      helper : function(e, domTarget) {
        var elmOverlay = $('<div />', { 'class' : 'space-navigation-reorder-overlay'});
            elmOverlay.append($(domTarget).children().clone());
        return elmOverlay;
      },
      update: _.debounce(onReorderingChange, 500)
    });

    elmSpaceNavigationAppNav.disableSelection();
    elmSpaceNavigationAppNav.addClass('reorder-active');

    helpers.showAllApps();

    elmSpaceNavigation.bind('outsideclick', onReorderingOutsideClick);
  }

  function disableReordering() {
    elmSpaceNavigationAppNav.removeClass('reorder-active');
    elmSpaceNavigationAppNav.find('a').each(function() {
      var elmLink = $(this);
      elmLink.attr('href', elmLink.attr('data-href'));
    });

    helpers.hideAllApps();

    $('.space-navigation-reorder-overlay').remove();
  }

  function render() {
    if (!elmSpaceNavigation || elmSpaceNavigation.length === 0) {
      return null;
    }

    var appNavBottomPosition = elmSpaceNavigation.offset().top + elmSpaceNavigation.height();
    var elmAppItems = elmSpaceNavigationAppNav.find('li');
    var hiddenItems = [];

    _.each(elmAppItems, function(domItem) {
      var elmTarget = $(domItem);
      var elmTopPosition = elmTarget.offset().top;
      if (elmTopPosition > appNavBottomPosition) {
        hiddenItems.push(elmTarget);
      }
    });

    if (hiddenItems && hiddenItems.length) {
      elmSpaceNavigation.addClass('show-more');
    }
    else {
      elmSpaceNavigation.removeClass('show-more');
    }

    eventUI.unbind('mousedown', '#space-navigation li.app:not(.core)', onAppIconMouseDown);
    eventUI.unbind('mouseup', '#space-navigation li.app:not(.core)', onAppIconMouseUp);

    if (elmSpaceNavigation.hasClass('reorder-enabled')) {
      eventUI.bind('mousedown', '#space-navigation li.app:not(.core)', onAppIconMouseDown);
      eventUI.bind('mouseup', '#space-navigation li.app:not(.core)', onAppIconMouseUp);
    }

    elmSpaceNavigation.removeClass('faded-out');
  }

  function onDomReady() {
    elmSpaceNavigation = $('#space-navigation');
    elmSpaceNavigationAppNav = elmSpaceNavigation.find('ul.app-nav');
    elmSpaceNavigationToggleAllApps = elmSpaceNavigation.find('.app-nav-more-link');

    render();
  }

  function toggleShowAll(showAll) {
    if (typeof showAll !== 'boolean') {
      showAll = !open;
    }

    if (showAll) {
      helpers.showAllApps();
    } else {
      helpers.hideAllApps();
    }
  }

  function onAddAppLinkClicked(elmTarget, e) {
    $.cookie("last-space-id", elmSpaceNavigation.data('space-id'), { path: '/', domain: podioConfig.base_domain});

    if (!_.isElement(_addAppModalNode)) {
      _addAppModalNode = document.body.appendChild(document.createElement('div'));
    }

    _addAppModalInstance = ReactDOM.render(AddAppModalComponent({}), _addAppModalNode);
    _addAppModalInstance.modal.current.open();
  }

  function onPublishSpaceClicked(elmTarget, e) {
    var spaceId = elmSpaceNavigation.data('space-id');
    var baseUrl = elmTarget.data('base-url');

    shareSpaceModal.show(spaceId, baseUrl);
  }

  function onAppIconMouseUp(elmTarget, e) {
    clearTimeout(pressTimer);
  }

  function onAppIconMouseDown(elmTarget, e) {
    pressTimer = window.setTimeout(function() {
      activateReordering();
    }, 1000);
  }

  function onReorderingOutsideClick(elmTarget, e) {
    disableReordering();
  }

  function onBodyResize() {
    render();
  }

  function init() {
    elmSpaceNavigation = $('#space-navigation');
    elmSpaceNavigationAppNav = elmSpaceNavigation.find('ul.app-nav');
    elmSpaceNavigationToggleAllApps = elmSpaceNavigation.find('.app-nav-more-link');

    render();
  }

  podioEvent.bind('resize', _.debounce(onBodyResize, 30), this);
  podioEvent.bind(podioEvent.Types.init, onDomReady, this);

  podioEvent.bind('appview:toggleFullscreen', function (fullScreen) { toggleShowAll(!fullScreen); });
  eventUI.bind('click', '#space-navigation .app-nav-more-link', toggleShowAll);
  eventUI.bind('click', '#space-navigation .core.app-apps a', onAddAppLinkClicked);
  eventUI.bind('click', '#space-navigation .publish-space, .publish-space-trigger:not(".disabled")', onPublishSpaceClicked);

  return {
    init: init
  };

});

